import React from 'react'
import Hero from '../2'
import { RealEstateDataPageComponentData } from 'types'
//Helpers

const HeroVideos = ({ ...props }: RealEstateDataPageComponentData) => {
  return (
    <Hero
      {...props}
      height={{ desktop: '90', mobile: '85', scalePixels: false }}
    />
  )
}

export default HeroVideos
